import type { OutreachPost as OutreachPostType } from "./outreach.types";
import { OutreachButtonAction } from "./OutreachButtonAction";
import { OutreachPost } from "./OutreachPost";

export type Props = {
  /** Title for the section */
  title?: string;
  /** Subtitle for the section */
  subtitle?: string;
  /** Description for the section */
  description?: string;
  /** Download URL for zip file */
  href: string;
  /** Button label */
  label: string;
  /** Array of post image URLs */
  posts: OutreachPostType[];
};

/**
 * Displays a list of social media post images with a download-all button.
 */
export function OutreachPostList({
  posts,
  title,
  subtitle,
  description,
  href,
  label,
}: Props) {
  return (
    <OutreachButtonAction
      title={title}
      subtitle={subtitle}
      description={description}
      href={href}
      label={label}
    >
      <div className="flex flex-wrap gap-4">
        {posts.map((src, index) => (
          <OutreachPost key={src} src={src} label={`${title || "Post"} ${index + 1}`} />
        ))}
      </div>
    </OutreachButtonAction>
  );
}

